(function () {
  function isAmorePage() {
    var form = document.querySelector('product-form[data-dbs-amore="true"]');
    return !!form;
  }

  function unavailableBlock(node) {
    if (!(node instanceof Element)) return null;
    var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
    if (!/Pickup currently unavailable/i.test(text)) return null;

    var candidates = [
      node.closest('li'),
      node.closest('[role="listitem"]'),
      node.closest('.pickup-location'),
      node.closest('.store-location'),
      node.closest('.location-item'),
      node.closest('.location'),
      node.closest('div')
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      var el = candidates[i];
      if (!el) continue;
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (/Pickup currently unavailable/i.test(t)) return el;
    }
    return node;
  }

  function clean(root) {
    if (!isAmorePage()) return;

    var scope = root || document;
    var nodes = scope.querySelectorAll
      ? scope.querySelectorAll('p, span, div, li, [role="listitem"]')
      : [];

    for (var i = 0; i < nodes.length; i += 1) {
      var text = (nodes[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (!/Pickup currently unavailable/i.test(text)) continue;

      var block = unavailableBlock(nodes[i]);
      if (block) {
        block.style.setProperty('display', 'none', 'important');
        block.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function schedule(root) {
    setTimeout(function () { clean(root || document); }, 25);
    setTimeout(function () { clean(root || document); }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(document); });
  } else {
    schedule(document);
  }

  new MutationObserver(function (mutations) {
    if (!isAmorePage()) return;
    for (var i = 0; i < mutations.length; i += 1) {
      var added = mutations[i].addedNodes || [];
      for (var j = 0; j < added.length; j += 1) {
        if (added[j].nodeType === 1) {
          schedule(added[j]);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();